import {
  Box,
  Image,
  Text,
  Heading,
  Stack,
  Container,
  SimpleGrid,
  Button,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

import Navbar from "./Navbar";
import Footer from "./Footer";
import { useAuth } from './AuthContext';

import HeroImage from "./images/stamps.png";

const TechnicalHomepage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const technicalSections = [
    {
      title: "API Documentation",
      description: "View API Swaggers, workflow tools, and technical endpoints",
      path: "/technical/api",
      color: "blue.600"
    },
    {
      title: "Security & Authentication",
      description: "Manage Auth0 settings, user permissions, and security configurations",
      path: "/technical/security",
      color: "purple.600"
    },
    {
      title: "Client Implementations",
      description: "Client-specific configurations and deployment settings",
      path: "/technical/clients",
      color: "green.600"
    },
  ];

  return (
    <Box>
      <Navbar />

      {/* Background image */}
      <Image
        src={HeroImage}
        alt="Hero Watermark"
        width="100%"
        height="100%"
        objectFit="cover"
        opacity={0.30}
        position="absolute"
        top={0}
        left={0}
        zIndex={-1}
        filter="blur(1px)"
      />

      {!user ? (
        <Container maxW="container.md" py={20}>
          <Box
            bg="white"
            p={6}
            borderRadius="md"
            boxShadow="md"
            textAlign="center"
          >
            <Text fontSize="md">
              You must be logged in to view this content.
            </Text>
          </Box>
        </Container>
      ) : (
        <Container maxW="container.xl" py={8}>
          <Stack spacing={8} align="stretch">
            {/* Hero Section */}
            <Box
              bg="rgba(255,255,255,0.95)"
              p={8}
              borderRadius="lg"
              boxShadow="xl"
              textAlign="center"
            >
              <Heading
                fontSize="4xl"
                mb={4}
                color="gray.800"
                fontWeight="bold"
              >
                Technical Administration
              </Heading>
              <Text fontSize="lg" color="gray.700" lineHeight="1.8">
                Platform configuration, API documentation, and security management
              </Text>
            </Box>

            {/* Technical Sections Grid */}
            <SimpleGrid columns={{ base: 1, md: 3 }} spacing={6}>
              {technicalSections.map((section) => (
                <Box
                  key={section.path}
                  bg="rgba(255,255,255,0.9)"
                  p={6}
                  borderRadius="md"
                  boxShadow="lg"
                  border="1px solid #e2e8f0"
                  textAlign="center"
                  transition="all 0.2s"
                  _hover={{
                    transform: "translateY(-4px)",
                    boxShadow: "xl",
                    borderColor: section.color
                  }}
                >
                  <Heading size="md" mb={3} color={section.color}>
                    {section.title}
                  </Heading>
                  <Text fontSize="sm" color="gray.600" mb={4}>
                    {section.description}
                  </Text>
                  <Button
                    colorScheme={section.color.split('.')[0]}
                    size="sm"
                    onClick={() => navigate(section.path)}
                  >
                    Access
                  </Button>
                </Box>
              ))}
            </SimpleGrid>
          </Stack>
        </Container>
      )}
      <Footer />
    </Box>
  );
};

export default TechnicalHomepage;
